import { Commit } from 'vuex';

interface GlobalLoaderState {
  globalLoading: boolean,
}

export default {

  namespaced: false,

  state: (): GlobalLoaderState => ({
    globalLoading: false,
  }),

  mutations: {
    SET_GLOBAL_LOADING_STATUS: (state: GlobalLoaderState, loading: boolean) => {
      state.globalLoading = loading;
    },
  },

  actions: {
    global_loading_start({ commit }: {commit: Commit }) {
      commit('SET_GLOBAL_LOADING_STATUS', true);
    },
    global_loading_stop({ commit }: {commit: Commit }) {
      commit('SET_GLOBAL_LOADING_STATUS', false);
    },
  },

  getters: {
    global_loading: (state: GlobalLoaderState) => state.globalLoading,
  },

};
